import { HttpClientModule } from "@angular/common/http";
import { ErrorHandler, Injectable, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ENV } from "@app/env";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import * as Sentry from "@sentry/browser";
import { FroalaEditorModule, FroalaViewModule } from "angular-froala-wysiwyg";
import { AngularFireModule } from "angularfire2";
import { AngularFireAuthModule } from "angularfire2/auth";
import { AngularFireDatabaseModule } from "angularfire2/database";
import { AngularFirestoreModule } from "angularfire2/firestore";
import { AngularFireStorageModule } from "angularfire2/storage";
import "froala-editor/js/froala_editor.pkgd.min.js";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { SharedComponentsModule } from "../components/shared-components.module";
import { DirectivesModule } from "../directives/directives.module";
import { CategoriesFormComponent } from "../pages/categories/components/categories-form/categories-form.component";
import { FormQuestionComponent } from "../pages/form-users/components/form-question/form-question.component";
import { FormUsersFormComponent } from "../pages/form-users/components/form-users-form/form-users-form.component";
import {
  BusinessAgendaFormComponent,
} from "../pages/interactivity/pages/business-view/components/business-agenda-form/business-agenda-form";
import {
  BusinessViewFormComponent,
} from "../pages/interactivity/pages/business-view/components/business-view-form/business-view-form";
import {
  ProfileUsersFormComponent,
} from "../pages/interactivity/pages/profiles-users/components/profile-users-form/profile-users-form.component";
import {
  PollFormQuestionAnswerComponent,
} from "../pages/poll/components/question-answer-form/question-answer-form.component";
import {
  VotingFormQuestionAnswerComponent,
} from "../pages/voting/components/questions-answers-form/questions-answers-form.component";
import { PipesModule } from "../pipes/pipes.module";
import { PROVIDERS } from "../providers/index";
import { SharedModule } from "../shared/shared.module";
import { RebusAdminApp } from "./app.component";
// import { FullCalendarModule } from '@fullcalendar/angular';

Sentry.init({
  dsn: "https://6f57ab9edbfc4c4286f78478784aaf20@sentry.io/1413872",
});

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  public handleError(error) {
    Sentry.captureException(error.originalError || error);
    throw error;
  }
}

export const FIREBASE_CONFIG = {
  apiKey: ENV.firebase.apiKey,
  authDomain: ENV.firebase.authDomain,
  databaseURL: ENV.firebase.databaseURL,
  messagingSenderId: ENV.firebase.messagingSenderId,
  projectId: ENV.firebase.projectId,
  storageBucket: ENV.firebase.storageBucket,
};

// tslint:disable-next-line:max-classes-per-file
@NgModule({
  bootstrap: [IonicApp],
  declarations: [
    RebusAdminApp,
    PollFormQuestionAnswerComponent,
    VotingFormQuestionAnswerComponent,
    CategoriesFormComponent,
    ProfileUsersFormComponent,
    FormUsersFormComponent,
    FormQuestionComponent,
    BusinessViewFormComponent,
    BusinessAgendaFormComponent,
  ],
  entryComponents: [
    RebusAdminApp,
    PollFormQuestionAnswerComponent,
    VotingFormQuestionAnswerComponent,
    CategoriesFormComponent,
    ProfileUsersFormComponent,
    FormUsersFormComponent,
    FormQuestionComponent,
    BusinessViewFormComponent,
    BusinessAgendaFormComponent,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(RebusAdminApp, {
      mode: "md",
    }),
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    AngularFireModule.initializeApp(FIREBASE_CONFIG),
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    BrowserAnimationsModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    !(ENV.mode === "Production") ? StoreDevtoolsModule.instrument({ maxAge: 25 }) : [],
    SharedComponentsModule,
    SharedModule,
    HttpClientModule,
    PipesModule,
    DirectivesModule,
    // FullCalendarModule,
  ],
  providers: [
    ...PROVIDERS,
    // FIXME: esto debe se solo en prod
    { provide: ErrorHandler, useClass: ENV.mode !== "Production" ? IonicErrorHandler : IonicErrorHandler },
  ],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts